import * as Yup from 'yup';

import { parseDataToApi } from '~/utils/reprocess';

export async function validate(data) {
  try {
    const schema = Yup.object().shape({
      start_at: Yup.string().required('Este campo é obrigatório'),
      end_at: Yup.string().required('Este campo é obrigatório'),
    });

    const parsedData = parseDataToApi(data);

    await schema.validate(parsedData, { abortEarly: false });

    return parsedData;
  } catch (error) {
    const errorMessages = {};

    if (error instanceof Yup.ValidationError) {
      error.inner.forEach(err => {
        if (!errorMessages[err.path]) errorMessages[err.path] = err.message;
      });
    }

    return { errorMessages };
  }
}
